<template>
    <div>
        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-select
                    :options="form.sexos"
                    :validations="validations.sexo"
                    label="Sexo"
                    show-default-option
                    text-field="descricao"
                    v-model="model.sexoId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.caracteristicasFisicas"
                    label="Características físicas"
                    rows="5"
                    v-model="model.caracteristicasFisicas"
                />
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
export default {
    computed: {
        validations() {

            return {
                sexo: { required: true },
                caracteristicasFisicas: { required: true, max: 500 }
            }
        },
    },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    }
}
</script>